module.exports = __webpack_public_path__ + "static/media/Webinar-bro.a0c66505.png";